<div class="switch-event-wrapper">
  <div class="switch-event">

    <!-- Desktop -->

    <div class="ui-current-events">
      <h6><span>Upcoming Events</span></h6>
      <div class="event-item-wrapper"
           (click)="onNationalTeamSelect(nationalTeam)"
           *ngFor="let nationalTeam of nationalTeamsService?.nationalTeams"
           [ngClass]="{'active': nationalTeam.teamId === nationalTeamsService?.selectedNationalTeam?.teamId}">
        <div class="event-item cursor-hand {{nationalTeam?.cssClass}}">
          <div>
            <h3>{{ nationalTeam?.name }}</h3>
            <div class="event-date">
              {{ nationalTeam?.calendarYear }}
              <span class="program">{{nationalTeam?.programGroupName}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="nationalTeamsService?.pastNationalTeams.length > 0" class="ui-past-events">
      <h6><span>Past Events</span></h6>

      <div class="event-item-wrapper"
           (click)="onNationalTeamSelect(nationalTeam)"
           *ngFor="let nationalTeam of nationalTeamsService?.pastNationalTeams"
           [ngClass]="{'active': nationalTeam.teamId === nationalTeamsService?.selectedNationalTeam?.teamId}">
        <div class="event-item cursor-hand {{nationalTeam?.cssClass}}">
          <div>
            <h3>{{ nationalTeam?.name }}</h3>
            <div class="event-date">
              {{ nationalTeam?.calendarYear }}
              <span class="program">{{nationalTeam?.programGroupName}}</span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>